<template>
  <div>
    <div class="new_content">
      <div class="new_jpkc_erji">
        <div class="new_webposition">
          账号设置<span class="nje_jiange">&gt;</span>
          <div v-if="baseVisible == true" class="nje_last">基本信息</div>
          <div v-if="phoneVisible == true" class="nje_last">验证手机号</div>
          <div v-if="cellVisible == true" class="nje_last">修改手机号</div>
          <!--<div v-if="emailVisible == true" class="nje_last">邮箱验证</div>-->
          <div v-if="pwdVisible == true" class="nje_last">修改密码</div>
        </div>
        <div class="new_yxdt">
          <div class="new_yxdt_tab">
            <ul id="new_yxdt_tab_all">
              <li>
                <a
                  id="basicUpdate"
                  :class="{ new_yxdt_tab_sel: baseVisible }"
                  href="javascript:"
                  @click="changeTabs(1)"
                >基本信息</a
                >
              </li>
              <li>
                <a
                  id="mobileUpdate"
                  :class="{ new_yxdt_tab_sel: phoneVisible }"
                  href="javascript:"
                  @click="changeTabs(2)"
                >验证手机号</a
                >
              </li>
              <li>
                <a
                  id="mobileUpdate"
                  :class="{ new_yxdt_tab_sel: cellVisible }"
                  href="javascript:"
                  @click="changeTabs(5)"
                >修改手机号</a
                >
              </li>
              <!--<li>-->
              <!--  <a-->
              <!--    id="emailUpdate"-->
              <!--    :class="{ new_yxdt_tab_sel: emailVisible }"-->
              <!--    href="javascript:"-->
              <!--    @click="changeTabs(3)"-->
              <!--  >邮箱验证</a-->
              <!--  >-->
              <!--</li>-->
              <li>
                <a
                  id="passwordUdate"
                  :class="{ new_yxdt_tab_sel: pwdVisible }"
                  href="javascript:"
                  @click="changeTabs(4)"
                >修改密码</a
                >
              </li>
            </ul>
          </div>
          <!--基本信息开始-->
          <div
            v-show="baseVisible == true"
            class="new_jpkc_list"
            style="padding-left:15px;border-left:1px #CCCCCC solid;position:relative"
          >
            <!--修改头像-->
            <div class="new_upload_head">
              <!--:on-preview="handlePreview"
                                  :on-remove="handleRemove"-->
              <el-form ref="form">
                <el-form-item v-model="form.imageUrl" prop="imageUrl">
                  <el-upload
                    :action="uploadUrl"
                    :before-upload="beforeAvatarUpload"
                    :on-success="handleAvatarSuccess"
                    class="avatar-uploader"
                  >
                    <img
                      v-if="form.imageUrl"
                      :src="form.imageUrl"
                      alt=""
                      class="avatar"/>
                    <img
                      v-else
                      alt=""
                      class="avatar"
                      src="https://source.yiboshi.com/user/GetUserImage.jpeg"/>
                  </el-upload>
                </el-form-item>
              </el-form>
              <span class="new_upload_head_text">点击图片修改头像</span>
            </div>
            <div class="new_userInfo_box">
              <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-width="100px"
              >
                <el-form-item label="真实姓名" prop="realname">
                  <el-input
                    v-model="form.realname"
                    class="baseInput"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="用户名" prop="userName">
                  <el-input
                    v-model="form.userName"
                    class="baseInput"
                  ></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                  <el-radio-group v-model="form.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="证件类型" prop="cardType">
                  <el-select
                    v-model="form.cardType"
                    disabled
                    placeholder="请选择证件类型"
                  >
                    <el-option
                      v-for="item in cardTypeOptions"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="证件号" prop="cardNumber">
                  <el-input
                    v-model="form.cardNumber"
                    class="baseInput"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="所在单位" prop="companyName">
                  <!-- <el-input v-model="form.companyName" class="baseInput" disabled></el-input> -->
                  <el-select
                    v-model="form.companyName"
                    :disabled="isAlterOrg === 1"
                    :loading="compLoading"
                    :no-data-text="compPrompt"
                    :remote-method="remoteSearchComp"
                    filterable
                    placeholder="请输入关键词"
                    remote
                    style="width: 100%;width:350px"
                    @change="orgIdChange"
                  >
                    <el-option
                      v-for="item in compOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                      <span style="float: left">{{ item.name }}</span>
                      <span
                        style="float: right; color: #8492A6; font-size: 13px;margin-left: 10px"
                      >{{
                          formatRegion(
                            item.province,
                            item.city,
                            item.county,
                            item.rural
                          )
                        }}</span
                      >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所在科室" prop="department">
                  <el-autocomplete
                    v-model="form.department"
                    :fetch-suggestions="searchDepartment"
                    placeholder="请输入内容"
                    @blur="departmentBlur"
                    @select="departmentSelect"
                  ></el-autocomplete>
                </el-form-item>
                <el-form-item label="人员类别" prop="personType">
                  <el-select
                    v-model="form.personType"
                    placeholder="请选择人员类别"
                    @change="changePersonType"
                  >
                    <el-option
                      v-for="item in personTypeOptions"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="乡村医生" prop="countryDoctor">
                  <el-select v-model="form.countryDoctor" placeholder="请选择">
                    <el-option :value="1" label="是"></el-option>
                    <el-option :value="0" label="否"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item labelWidth="0" prop="specialty">
                  <el-col :span="12">
                    <el-form-item label="专业一" prop="specialtyId1">
                      <el-select
                        v-model="form.specialtyId1"
                        placeholder="请选择专业1"
                        @change="changeSpecialtyId1"
                      >
                        <el-option
                          v-for="item in specialtyId1Options"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="专业二"
                      labelWidth="100"
                      prop="specialtyId2"
                    >
                      <el-select
                        v-model="form.specialtyId2"
                        placeholder="请选择专业2"
                      >
                        <el-option
                          v-for="item in specialtyId2Options"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item labelWidth="0">
                  <el-col :span="12">
                    <el-form-item label="职称" prop="title">
                      <el-select v-model="form.title" placeholder="请选择职称">
                        <el-option
                          v-for="item in titleOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="获取职称日期"
                      labelWidth="100"
                      prop="title"
                    >
                      <el-date-picker
                        id="title"
                        v-model="form.getTitleDate"
                        placeholder="请选择获取职称日期"
                        type="date"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item labelWidth="0">
                  <el-col :span="12">
                    <el-form-item label="执业类别" prop="occupationType">
                      <el-select
                        v-model="form.occupationType"
                        placeholder="请选择执业类别"
                      >
                        <el-option
                          v-for="item in occupationTypeOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="执业资格"
                      prop="practicingRequirements"
                    >
                      <el-select
                        v-model="form.practicingRequirements"
                        placeholder="请选择执业资格"
                      >
                        <el-option
                          v-for="item in requirementsOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item label="资格证书编号" prop="certificateNumber">
                  <el-input
                    v-model="form.certificateNumber"
                    class="baseInput"
                  ></el-input>
                </el-form-item>
                <el-form-item label="执业证书编号" prop="practisingCertificate">
                  <el-input
                    v-model="form.practisingCertificate"
                    class="baseInput"
                  ></el-input>
                </el-form-item>
                <el-form-item labelWidth="0">
                  <el-col :span="12">
                    <el-form-item label="学历" prop="education">
                      <el-select
                        v-model="form.education"
                        placeholder="请选择学历"
                      >
                        <el-option
                          v-for="item in educationOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="院内职务" prop="duty">
                      <el-select
                        v-model="form.duty"
                        placeholder="请选择院内职务"
                      >
                        <el-option
                          v-for="item in dutyOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item labelWidth="0">
                  <el-col :span="12">
                    <el-form-item label="出生日期" prop="birthday">
                      <el-date-picker
                        id="birthday"
                        v-model="form.birthday"
                        type="date"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="民族" prop="nation">
                      <el-select
                        v-model="form.nation"
                        filterable
                        placeholder="请选择民族"
                      >
                        <el-option
                          v-for="item in nationOptions"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item label="政治面貌" prop="politicsStatus">
                  <el-select
                    v-model="form.politicsStatus"
                    placeholder="请选择政治面貌"
                  >
                    <el-option
                      v-for="item in politicsStatusOptiosn"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="text-align: center;">
                  <el-button
                    v-loading.fullscreen.lock="fullscreenLoading"
                    style="width:40%; margin-top: 20px;"
                    type="primary"
                    @click="editUserInfo"
                  >保&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;存
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!--基本信息结束-->
          <!--手机验证开始-->
          <div
            v-show="phoneVisible == true"
            class="new_jpkc_list"
            style="padding-left:15px;border-left:1px #CCCCCC solid;"
          >
            <div class="new_userInfo_box">
              <!-- <div class="new_reminder_txt">
                <span>!</span
                >在忘记密码后，可通过手机号码快速找回密码。<br />如果已经更换手机号码，建议立刻更新验证。
              </div> -->
              <el-form
                ref="mobileForm"
                :model="mobileForm"
                :rules="mobileRules"
                label-width="100px"
              >
                <el-form-item
                  v-if="oldMobileExist == true"
                  label="手机号码"
                  prop="oldMobile"
                >
                  <el-input
                    v-model="mobileForm.oldMobile"
                    class="baseInput"
                    disabled
                  ></el-input>
                  <el-link :underline="false" type="success">手机号已验证</el-link>
                </el-form-item>
                <el-form-item v-else label="手机号码" prop="newMobile">
                  <el-input
                    v-model="mobileForm.newMobile"
                    class="baseInput"
                    placeholder="请输入11位手机号码"
                  ></el-input>
                  <!--<el-button :disabled="sendSmsButtonDisabled" size="small" style="margin-left: 20px;"-->
                  <!--  type="primary"-->
                  <!--  @click.native="sendSmsMethod('mobileForm','newMobile',1)">{{ sendSmsButtonText }}-->
                  <!--</el-button>-->
                </el-form-item>
                <el-form-item v-if="!oldMobileExist" label="验证码" prop="mobileCode">
                  <!-- 滑块验证 -->
                  <div v-show="verifyShow" class="verifyMain">
                    <Verify
                      ref="verify"
                      :captchaType="'blockPuzzle'"
                      :imgSize="{
                        width: '240px',
                        height: '120px',
                      }"
                      :mode="'fixed'"
                      @success="success"
                    ></Verify>
                    <div v-show="verifyOK" class="verifyOK">
                      <i
                        class="el-icon-success"
                        style="color:#67C23A;margin-left:12px;margin-right:8px"
                      ></i>
                      验证通过
                    </div>
                  </div>
                  <el-input
                    v-model="mobileForm.mobileCode"
                    :disabled="oldMobileExist"
                    class="baseInput"
                    placeholder="请输入短信验证码"
                    style="width: 280px;"
                  ></el-input>
                  <el-button
                    :disabled="oldMobileExist || sendSmsButtonDisabled"
                    size="small"
                    style="margin-left: 10px;padding:9px 9px;"
                    type="primary"
                    @click.native="sendSmsMethod('mobileForm', 'newMobile', 1)"
                  >{{ sendSmsButtonText }}
                  </el-button>
                  <!--<a class="yz ml-20 pa" href="javascript:;"-->
                  <!--  title="①手机接收短信偶尔会有延时状况，请耐心等待;②尝试到手机短信拦截记录里找找看;③若有疑问请拨打客服电话：400-822-2055">-->
                  <!--  没有收到验证码？</a>-->
                </el-form-item>
                <el-form-item v-if="!oldMobileExist">
                  <el-button
                    :disabled="oldMobileExist || verifyOkBtn"
                    style="width:30%;"
                    type="primary"
                    @click.native="editUserMobile('mobileForm', 1)"
                  >确&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;定
                  </el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!--手机验证结束-->
          <!-- 修改手机号开始 -->
          <div
            v-show="cellVisible == true"
            class="new_jpkc_list"
            style="padding-left:15px;border-left:1px #CCCCCC solid;"
          >
            <div class="step">
              <el-steps
                :active="tipactive"
                class="stepdiv"
                finish-status="success"
                simple
              >
                <el-step title="解绑原手机号"></el-step>
                <el-step title="绑定新手机号"></el-step>
                <el-step title="完成"></el-step>
              </el-steps>
            </div>
            <div v-show="cellactive == 1" class="mobileFormEdit">
              <el-form
                ref="mobileFormEdit"
                :model="mobileFormEdit"
                :rules="mobileRulesEdit"
                class="formcss"
                label-width="100px"
              >
                <el-form-item class="self" label="原手机号" prop="oldMobile">
                  <el-input
                    v-model="mobileFormEdit.oldMobile"
                    disabled
                    style="width:370px"
                  ></el-input>
                  <p
                    style="font-size:12px;color:#38BCD5;height:20px;padding:0px;line-height: 20px;"
                  >
                    注：如原手机号不可使用，请联系客服400-822-2055
                  </p>
                </el-form-item>
                <el-form-item label="验证码" prop="mobileCode">
                  <!-- 滑块验证 -->
                  <div v-show="verifyShow" class="verifyMain">
                    <Verify
                      ref="verify"
                      :captchaType="'blockPuzzle'"
                      :imgSize="{
                        width: '240px',
                        height: '120px',
                      }"
                      :mode="'fixed'"
                      @success="success"
                    ></Verify>
                    <div v-show="verifyOK" class="verifyOK">
                      <i
                        class="el-icon-success"
                        style="color:#67C23A;margin-left:12px;margin-right:8px"
                      ></i>
                      验证通过
                    </div>
                  </div>
                  <el-input
                    v-model="mobileFormEdit.mobileCode"
                    placeholder="请输入短信验证码"
                    style="width: 280px"
                  ></el-input>
                  <el-button
                    :disabled="sendSmsButtonTextEditOldDisabled"
                    size="small"
                    style="margin-left: 10px;padding:10px 9px;"
                    type="primary"
                    @click.native="
                      sendSmsMethod('mobileFormEdit', 'oldMobile', 4)
                    "
                  >
                    {{ sendSmsButtonTextEditOld }}
                  </el-button>
                  <!-- <a href="javascript:;" class="yz ml-20 pa"
                               title="①手机接收短信偶尔会有延时状况，请耐心等待;②尝试到手机短信拦截记录里找找看;③若有疑问请拨打客服电话：400-822-2055">没有收到验证码？</a> -->
                </el-form-item>
                <el-form-item>
                  <el-button
                    :disabled="editcellnextbtnDisabled"
                    style="width:276px;"
                    type="primary"
                    @click.native="nextMobile"
                  >下一步
                  </el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <div v-show="cellactive == 2" class="mobileFormEdit">
              <el-form
                ref="mobileFormEditNew"
                :model="mobileFormEditNew"
                :rules="mobileRulesNew"
                class="formcss"
                label-width="100px"
              >
                <el-form-item label="新手机号" prop="newMobile">
                  <el-input
                    v-model="mobileFormEditNew.newMobile"
                    placeholder="请输入11位手机号码"
                    style="width:370px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="mobileCode">
                  <!-- 滑块验证 -->
                  <div v-show="verifyShow" class="verifyMain">
                    <Verify
                      ref="verify"
                      :captchaType="'blockPuzzle'"
                      :imgSize="{
                        width: '240px',
                        height: '120px',
                      }"
                      :mode="'fixed'"
                      @success="success"
                    ></Verify>
                    <div v-show="verifyOK" class="verifyOK">
                      <i
                        class="el-icon-success"
                        style="color:#67C23A;margin-left:12px;margin-right:8px"
                      ></i>
                      验证通过
                    </div>
                  </div>
                  <el-input
                    v-model="mobileFormEditNew.mobileCode"
                    placeholder="请输入短信验证码"
                    style="width: 280px"
                  ></el-input>
                  <el-button
                    :disabled="sendSmsButtonTextEditNewDisabled"
                    size="small"
                    style="margin-left: 10px;padding:10px 9px;"
                    type="primary"
                    @click.native="
                      sendSmsMethod('mobileFormEditNew', 'newMobile', 5)
                    "
                  >
                    {{ sendSmsButtonTextEditNew }}
                  </el-button>
                  <!-- <a href="javascript:;" class="yz ml-20 pa"
                               title="①手机接收短信偶尔会有延时状况，请耐心等待;②尝试到手机短信拦截记录里找找看;③若有疑问请拨打客服电话：400-822-2055">没有收到验证码？</a> -->
                </el-form-item>
                <el-form-item>
                  <!-- <el-button
                type="primary"
                style="width:276px;"
                @click.native="nextMobileok"
                >确定</el-button
              > -->
                  <el-button
                    :disabled="editcellokbtnDisabled"
                    style="width:276px;"
                    type="primary"
                    @click.native="editUserMobile('mobileFormEdit', 2)"
                  >确定
                  </el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
          
          <!-- 修改手机号结束 -->
          <!--邮箱验证开始-->
          <div
            v-show="emailVisible == true"
            class="new_jpkc_list"
            style="padding-left:15px;border-left:1px #CCCCCC solid;"
          >
            <div class="new_userInfo_box">
              <div class="new_reminder_txt">
                <span>!</span
                >在忘记密码后，可通过邮箱快速找回密码。<br/>如果已经更换邮箱，建议立刻更新验证。
              </div>
              <el-form
                ref="emailForm"
                :model="emailForm"
                :rules="emailRules"
                label-width="100px"
              >
                <el-form-item
                  v-if="oldEmailExist == true"
                  label="已验证邮箱"
                  prop="oldEmail"
                >
                  <el-input
                    v-model="emailForm.oldEmail"
                    class="baseInput"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="新邮箱" prop="newEmail">
                  <el-input
                    v-model="emailForm.newEmail"
                    class="baseInput"
                  ></el-input>
                  <el-button
                    :disabled="sendEmailButtonDisabled"
                    size="small"
                    style="margin-left: 20px;"
                    type="primary"
                    @click.native="sendEmailMethod"
                  >{{ sendEmailButtonText }}
                  </el-button>
                </el-form-item>
                <el-form-item label="验证码" prop="emailCode">
                  <el-input
                    v-model="emailForm.emailCode"
                    class="baseInput"
                  ></el-input>
                  <a
                    class="yz ml-20 pa"
                    href="javascript:"
                    title="1.电子邮件偶尔会有延时状况，请耐心等待2.尝试到垃圾邮件里找找看3.若有疑问请拨打客服电话：400-822-2055"
                  >
                    没有收到验证码？</a
                  >
                </el-form-item>
                <el-form-item>
                  <el-button
                    style="width:30%;"
                    type="primary"
                    @click.native="editUserEmail"
                  >保&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;存
                  </el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!--手邮箱验证结束-->
          <!--修改密码开始-->
          <div
            v-show="pwdVisible == true"
            class="new_jpkc_list"
            style="padding-left:15px;border-left:1px #CCCCCC solid; width: 660px"
          >
            <ChangePasswordBase v-if="pwdVisible"></ChangePasswordBase>
          </div>
          <!--修改密码结束-->
        </div>
      </div>
    </div>
    <!-- 滑块验证 -->
    <div class="verify_box">
      <Verify v-if="verifyShow" ref="verifyRef" :captchaType="'blockPuzzle'"
        :imgSize="{ width: '240px', height: '120px'}"
        :mode="'pop'" @close="verifyClose"
        @success="verifySuccess"></Verify>
    </div>
  </div>
</template>

<script>
import util from '../../common/js/util'
import { mapActions, mapGetters } from 'vuex'
import sha256 from 'crypto-js/sha256'
import md5 from 'crypto-js/md5'
import Verify from '../../components/verifition/Verify'
import { getsms, smsSendByUuid, smsvalidate, smsValidateByUuid } from '../../api/apiLoginVerify'
import { aesEncryptWord } from '../../components/verifition/utils/ase.js'
import { isChineseIdCard, passwordvali } from '../../utils/validate.js'
import {
  NumberReg,
  PasswordLengthRge,
  phoneReg,
  SpecialCharactersReg,
  UppercaseLowercaseReg
} from '../../utils/commonReg'

import {
  bindMobile,
  checkPwdRight,
  getdepartmentByOrgId,
  getSpecialty1Indexs,
  getSpecialty2Indexs,
  getUserDictByColumType,
  listCompany,
  nameSertIdAvailable,
  sendEmail,
  updatebindMobile,
  updateEmail,
  updatePassword,
  updateStudent,
  validateEmailCode,
  validateMobileCode,
  vftelUserEmail
} from '../../api/api'
import ChangePasswordBase from '../../components/ChangePassword/indexBase.vue'

export default {
  data() {
    var validateSpecialty = (rule, value, callback) => {
      if (!this.form.personType) {
        callback(new Error('请先选择人员类别'))
      } else if (!this.form.specialtyId1) {
        callback(new Error('请选择专业一'))
      } else if (!this.form.specialtyId2) {
        callback(new Error('请选择专业二'))
      } else {
        callback()
      }
    }
    
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
        // nameSertIdAvailable({ type: 3, value: value }).then(({ data }) => {
        //     if (data.code == 0) {
        //       callback()
        //     } else {
        //       callback(new Error(data.msg))
        //     }
        //   })
      }
    }
    
    var validateVPhoneCode = (rule, value, callback) => {
      if (!this.mobileForm.newMobile) {
        callback(new Error('请先获取手机验证码'))
      } else if (!value) {
        callback(new Error('请输入手机验证码'))
      } else {
        callback()
        
        // validateMobileCode({ key: this.mobileCodeKey, code: value }).then(
        //   ({ data }) => {
        //     if (data.success == true) {
        //       callback()
        //     } else {
        //       callback(new Error(data.msg))
        //     }
        //   }
        // )
      }
    }
    
    var validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入邮箱'))
      } else if (
        !/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/.test(
          value
        )
      ) {
        callback(new Error('请输入正确的邮箱'))
      } else {
        vftelUserEmail({email: value}).then((response) => {
          if (response.status == 200) {
            if (response.data.status == 200) {
              callback()
            } else {
              callback(new Error(response.data.msg))
            }
          }
        })
      }
    }
    
    var validateEmailCodeFuc = (rule, value, callback) => {
      if (!this.emailForm.newEmail) {
        callback(new Error('请先输入邮箱'))
      } else if (!value) {
        callback(new Error('请输入邮箱验证码'))
      } else {
        validateEmailCode({email: this.emailForm.newEmail, code: value}).then(
          (response) => {
            let {data} = response
            if (response.status == 200) {
              if (data.status == 200) {
                callback()
              } else {
                callback(new Error('邮箱验证码错误'))
              }
            }
          }
        )
      }
    }
    
    var validateRePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (
        md5(value).toString() !== md5(this.pwdForm.newPwd).toString()
      ) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    
    var validatePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入旧密码'))
      } else {
        checkPwdRight({
          oldPwd: md5(value).toString(),
          userId: this.userInfo.id
        }).then((response) => {
          if (response.status == 200) {
            if (response.data.status == 200) {
              callback()
            } else {
              callback(new Error(response.data.msg))
            }
          }
        })
      }
    }
    
    var passnewvalidate = (rule, value, callback) => {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (md5(value).toString() == md5(this.pwdForm.oldPwd).toString()) {
        callback()
      } else if (!reg.test(value)) {
        callback(new Error('请输入8-16位的数字和字母组合的密码'))
      } else {
        callback()
      }
      
    }
    
    /**
     * @description: 用户名校验
     */
    const validateUsername = (rule, value, callback) => {
      var reg = /^[a-zA-Z][a-zA-Z0-9]*$/
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else if (isChineseIdCard(value)) {
        callback(new Error('身份证不可作为用户名'))
      } else if (reg.test(value) === false) {
        callback(new Error('用户名为6-20个字符，且字母在首位'))
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error('用户名为6-20个字符，且字母在首位'))
      } else {
        nameSertIdAvailable({
          type: 1,
          value: value,
          uuid: this.userInfo.uuid
        }).then(({data}) => {
          if (data.code === 0) {
            callback()
          } else {
            callback(new Error(data.msg))
          }
        })
      }
    }
    
    return {
      phoneReg: phoneReg,
      passwordvali: passwordvali,
      cellVisible: false,
      tipFlag: 0, //滑块标志
      tipactive: 0,
      cellactive: 1,
      verifyOK: false,
      verifyShow: false,
      captchaVerification: '',
      fullscreenLoading: false,
      uploadUrl: process.env.VUE_APP_API_URL + '/api/wechat/file/ImgFileUpload',
      baseVisible: true,
      phoneVisible: false,
      emailVisible: false,
      pwdVisible: false,
      oldMobileExist: false, //已有已验证的手机号
      mobileCodeKey: '',
      // sendSmsButtonDisabled: false,
      sendSmsButtonDisabledOld: false,
      sendSmsButtonDisabledNew: false,
      sendEmailButtonDisabled: false,
      // sendSmsButtonTextEditNewDisabled: false,
      sendSmsButtonTextEditOldDisabled: false,
      oldEmailExist: false,
      unbindActive: 0, //换绑手机号步骤条
      time: 0,
      timeOld: 0,
      timeNew: 0,
      timeEditOld: 0,
      timeEditNew: 0,
      timeEmail: 0,
      
      rules: {
        userName: [
          {required: true, validator: validateUsername, trigger: 'blur'}
        ],
        countryDoctor: [
          {required: true, message: '请选择乡村医生', trigger: 'change'}
        ],
        personType: [
          {required: true, message: '请选择人员类别', trigger: 'change'}
        ],
        specialty: [
          {required: true, validator: validateSpecialty, trigger: 'change'}
        ]
      },
      
      mobileForm: {
        oldMobile: '',
        newMobile: '',
        mobileCode: '',
        yzmbtn: false
      },
      mobileFormOld: {
        oldMobile: '',
        oldMobileCode: '',
        mobileCodeKey: ''
      },
      mobileFormNew: {
        newMobile: '',
        mobileCode: '',
        mobileCodeKey: ''
      },
      mobileFormEdit: {
        //修改手机号
        oldMobile: '',
        mobileCode: ''
      },
      mobileFormEditNew: {
        newMobile: '',
        mobileCode: '',
        yzmbtn: false
      },
      pwdForm: {
        // oldPwd: '',
        mobile: '', //手机号
        code: '', //短信验证码
        newPwd: '',
        reNewPwd: ''
      },
      emailForm: {
        oldEmail: '',
        newEmail: '',
        emailCode: ''
      },
      form: {
        id: '',
        realname: '',
        userName: '',
        sex: '',
        cardType: '',
        cardNumber: '',
        orgId: '',
        companyName: '',
        department: '',
        departmentId: '',
        countryDoctor: '', // 乡村医生
        personType: '',
        specialtyId1: '',
        specialtyId2: '',
        personTypeOld: '',
        specialtyId1Old: '',
        orgOld: '',
        title: '',
        getTitleDate: '',
        occupationType: '',
        practicingRequirements: '',
        certificateNumber: '',
        practisingCertificate: '',
        education: '',
        duty: '',
        birthday: '',
        nation: '',
        politicsStatus: '',
        isMobileVerify: '',
        isEmailVerify: '',
        imageUrl: ''
      },
      isAlterOrg: 1,
      compOptions: [], //单位下拉搜索
      compLoading: false, //单位下拉搜索的loading状态
      compPrompt: '无数据', //单位下拉无数据时的提示
      searchCount: 0, //单位搜索次数
      
      cardTypeOptions: [], //身份证类别
      personTypeOptions: [], //人员类别
      specialtyId1Options: [], //专业1
      specialtyId2Options: [], //专业2
      titleOptions: [], //职称
      occupationTypeOptions: [], //执业类别
      requirementsOptions: [], //执业资格
      educationOptions: [], //学历
      dutyOptions: [], //职称
      nationOptions: [], //民族
      politicsStatusOptiosn: [], // 政治面貌
      
      mobileRules: {
        newMobile: [
          {required: true, validator: validateMobile, trigger: 'blur'}
        ],
        mobileCode: [
          {required: true, validator: validateVPhoneCode, trigger: 'blur'}
        ]
      },
      mobileRulesOld: {
        oldMobile: [{required: true, trigger: 'blur'}],
        oldMobileCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      mobileRulesEdit: {
        oldMobile: [{required: true, trigger: 'blur'}],
        mobileCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      mobileRulesNew: {
        newMobile: [
          {required: true, validator: validateMobile, trigger: 'blur'}
        ],
        mobileCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      
      emailRules: {
        newEmail: [
          {required: true, validator: validateEmail, trigger: 'blur'}
        ],
        emailCode: [
          {required: true, validator: validateEmailCodeFuc, trigger: 'blur'}
        ]
      },
      
      pwdRules: {
        oldPwd: [{required: true, validator: validatePwd, trigger: 'blur'}],
        newPwd: [
          {required: true, validator: passnewvalidate, trigger: 'blur'}
        
        ],
        reNewPwd: [
          {required: true, validator: validateRePwd, trigger: 'blur'}
        ]
      },
      timer: {
        countDownText: '获取验证码',
        countDown: 60,
        interval: null
      },
      loading: false //提交loading
    }
  },
  mounted() {
    getUserDictByColumType({columnType: 1}).then((response) => {
      let {data} = response
      if (response.status == 200) {
        this.cardTypeOptions = data
      }
    })
    getUserDictByColumType({columnType: 2}).then((response) => {
      let {data} = response
      if (response.status == 200) {
        this.personTypeOptions = data
      }
    })
    getUserDictByColumType({columnType: 4}).then((response) => {
      let {data} = response
      if (response.status == 200) {
        this.titleOptions = data
      }
    })
    this.getOccupationType()
    this.getRequirements()
    this.getEducation()
    this.getDuty()
    this.getNation()
    this.getPoliticsStatus()
    this.getStudentDetail()
    
    this.initTabs()
  },
  components: {
    ChangePasswordBase,
    Verify
  },
  computed: {
    ...mapGetters(['userInfo']),
    editcellnextbtnDisabled() {
      //修改手机号 下一步
      if (this.mobileFormEdit.mobileCode.length > 0) {
        return false
      } else {
        return true
      }
    },
    editcellokbtnDisabled() {
      if (this.mobileFormEditNew.newMobile.length > 0 && this.mobileFormEditNew.mobileCode.length > 0) {
        return false
      } else {
        return true
      }
      
    },
    sendSmsButtonDisabled() {
      //验证手机号验证码按钮
      if (this.mobileForm.newMobile.length < 1 || this.oldMobileExist == true) {
        return true
      } else if (this.mobileForm.yzmbtn == true) {
        return true
      } else {
        return false
      }
    },
    sendSmsButtonTextEditNewDisabled() {
      //修改手机新手机号验证码按钮
      if (this.mobileFormEditNew.newMobile.length < 1 || this.mobileFormEditNew.yzmbtn) {
        return true
      } else {
        return false
      }
    },
    verifyOkBtn() {
      //验证手机号确定按钮
      if (
        this.mobileForm.newMobile.length < 1 ||
        this.mobileForm.mobileCode.length < 1 ||
        this.oldMobileExist == true
      ) {
        return true
      } else {
        return false
      }
    },
    sendSmsButtonText() {
      if (this.time > 0) {
        return this.time + 's'
      } else {
        this.mobileForm.yzmbtn = false
        return '获取验证码'
      }
      // return this.time > 0 ? this.time + 's' : '获取验证码'
    },
    sendSmsButtonTextOld() {
      return this.timeOld > 0 ? this.timeOld + 's' : '获取验证码'
    },
    sendSmsButtonTextNew() {
      return this.timeNew > 0 ? this.timeNew + 's' : '获取验证码'
    },
    sendSmsButtonTextEditOld() {
      //修改手机 old
      return this.timeEditOld > 0 ? this.timeEditOld + 's' : '获取验证码'
    },
    sendSmsButtonTextEditNew() {
      //修改手机 new
      if (this.timeEditNew > 0) {
        return this.timeEditNew + 's'
      } else {
        this.mobileFormEditNew.yzmbtn = false
        return '获取验证码'
      }
    },
    
    sendEmailButtonText() {
      return this.timeEmail > 0 ? this.timeEmail + 's' : '获取验证码'
    }
  },
  filters: {
    mobileFilter(val) {
      return val.replace(/^(\d{4})\d{4}(\d+)/, '$1****$2')
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    /**
     * @description: 进行滑块验证
     */
    performVerify() {
      this.loading = true
      this.verifyShow = true
      this.$nextTick(() => {
        this.$refs.verifyRef.show()
      })
    },
    /**
     * @description: 滑块成功回调
     */
    verifySuccess(verifyData) {
      this.verifyShow = false
      this.getCode(verifyData)
    },
    /**
     * @description: 滑块关闭回调
     */
    verifyClose() {
      if (this.loading) this.loading = false
    },
    /**
     * @description: 获取验证码
     */
    getCode(verifyData) {
      const params = {
        captchaVerification: verifyData.captchaVerification
      }
      // eslint-disable-next-line no-undef
      sliderSendCode(params).then((res) => {
        this.loading = false
        const {code, msg, data} = res
        if (code !== 0) {
          this.$message.error(msg)
          return
        }
        this.$message.success(data)
        this.startTimer()
      }).catch(() => {
        this.loading = false
      })
    },
    /**
     * @description: 启动计时器
     */
    startTimer() {
      this.timer.interval = setInterval(() => {
        if (this.timer.countDown > 0) {
          this.timer.countDown--
          this.timer.countDownText = `${ this.timer.countDown }s`
        } else {
          clearInterval(this.timer.interval)
          this.timer.countDown = 60
          this.timer.countDownText = '再次获取'
        }
      }, 1000)
    },
    ...mapActions(['userLogout']),
    /**
     * @description: 发送验证码
     * @author: lly
     */
    sendyzm() {
      let params = {}
      // 验证手机号
      if (this.tipFlag === 1) {
        params = {
          mobile: aesEncryptWord(this.mobileForm.newMobile),
          captchaVerification: this.captchaVerification.captchaVerification,
          flag: 3,
          uuid: this.userInfo.uuid
        }
      }
      if (this.tipFlag === 4) {
        params = {
          uuid: this.userInfo.uuid,
          captchaVerification: this.captchaVerification.captchaVerification,
          flag: 1
        }
      }
      if (this.tipFlag === 5) {
        params = {
          mobile: aesEncryptWord(this.mobileFormEditNew.newMobile),
          captchaVerification: this.captchaVerification.captchaVerification,
          flag: 2
        }
      }
      if (this.tipFlag === 4) {
        smsSendByUuid(params).then(res => {
          const {code, msg} = res
          if (code !== 0) {
            this.$message.error(msg)
            return
          }
          this.$message.success('已发送手机验证码')
          if (this.tipFlag === 4) {
            //修改手机号，old
            this.timeEditOld = 60
            this.smsTimerEditOld()
          }
          //修改手机号，old
          // this.timeEditOld = 60
          // this.smsTimerEditOld()
        }).catch(() => {
          this.loading = false
        })
      } else {
        getsms(params).then((res) => {
          this.$message.success('已发送手机验证码')
          if (this.tipFlag === 1) {
            //验证手机号
            this.time = 60
            this.smsTimer()
          }
          if (this.tipFlag === 5) {
            //修改手机号，new
            this.timeEditNew = 60
            this.smsTimerEditNew()
          }
        })
      }
    },
    
    nextMobile() {
      //修改手机号 下一步
      // this.cellactive++
      // if (this.cellactive++ > 2) this.cellactive = 0
      this.$refs.mobileFormEdit.validate((valid) => {
        if (valid) {
          const paramyzm = {
            uuid: this.userInfo.uuid,
            code: this.mobileFormEdit.mobileCode
          }
          smsValidateByUuid(paramyzm).then((res) => {
            const {code, msg} = res
            if (code === 0) {
              this.tipactive = 2
              this.mobileFormEditNew.newMobile = ''
              this.mobileFormEditNew.mobileCode = ''
              this.mobileFormEditNew.yzmbtn = false
              if (this.cellactive++ > 2) this.cellactive = 0
            } else {
              this.$message.warning(msg)
            }
          })
        } else {
          return false
        }
      })
    },
    success(params) {
      // this.verifyOK = true
      this.captchaVerification = params
      // setTimeout(() => {
      //   this.verifyShow = false
      //   this.verifyOK = false
      // }, 1000)
      this.verifyShow = false
      this.sendyzm()
    },
    /**
     * @description: 实时根据输入信息查询单位
     * @author: tanglitong
     */
    
    remoteSearchComp(compName) {
      if (compName) {
        this.compLoading = true
        listCompany({
          name: compName.replace(/'/g, ''),
          types: '1'
        }).then(({data, msg}) => {
          if (data) {
            this.compOptions = data
            this.compLoading = false
            this.compPrompt = '抱歉，没有找到单位，请重新输入关键字'
          } else {
            this.compOptions = []
            this.compPrompt = msg
            this.compLoading = false
          }
        })
        this.searchCount += 1
      } else {
        this.compOptions = []
        this.compPrompt = '请输入关键字'
      }
    },
    /**
     * @description: 自定义所在单位搜索后的地区展示
     * @author: tanglitong
     */
    
    formatRegion(province, city, county, rural) {
      let result = province
      if (city) {
        result += '-' + city
        if (county) {
          result += '-' + county
          if (rural) {
            result += '-' + rural
          }
        }
      }
      return result
    },
    /**
     * @description: 所在单位选择监听
     * @author: tanglitong
     */
    
    orgIdChange(val) {
      if (val) {
        this.form.orgId = val
      }
    },
    initTabs() {
      if (this.$route.query.phoneVisible != undefined) {
        this.changeTabs(2)
      } else if (
        this.$route.query.pwdVisible != undefined &&
        this.$route.query.baseVisible != undefined
      ) {
        this.baseVisible = false
      } else if (this.$route.query.pwdVisible != undefined) {
        this.baseVisible = false
        this.pwdVisible = this.$route.query.pwdVisible
        this.changeTabs(4)
      } else if (this.$route.query.baseVisible != undefined) {
        this.baseVisible = this.$route.query.baseVisible
        this.changeTabs(1)
      }
    },
    /**
     * @description: 个人信息查询
     */
    
    getStudentDetail() {
      const userInfo = this.userInfo
      this.mobileForm.oldMobile = userInfo.mobile
      this.mobileFormOld.oldMobile = userInfo.mobile
      this.mobileFormEdit.oldMobile = userInfo.mobile
      this.emailForm.oldEmail = userInfo.email
      this.form.imageUrl = userInfo.imageUrl
      this.form.id = userInfo.id
      this.form.realname = userInfo.realName
      this.form.userName = userInfo.userName
      this.form.isMobileVerify = userInfo.isMobileVerify
      this.form.isEmailVerify = userInfo.isEmailVerify
      this.form.sex = (userInfo.sex || userInfo.sex === 0) ? userInfo.sex.toString() : ''
      this.form.cardType = userInfo.credentialsType ? userInfo.credentialsType.toString() : ''
      this.form.cardNumber = userInfo.sertId
      this.form.orgId = userInfo.orgId
      this.form.orgOld = userInfo.orgId
      this.form.companyName = userInfo.companyName
      this.form.department = userInfo.departmentName
      this.form.departmentId = userInfo.department
      this.form.countryDoctor = userInfo.countryDoctor // 乡村医生
      this.form.personType = userInfo.personType ? userInfo.personType.toString() : ''
      this.form.personTypeOld = userInfo.personType ? userInfo.personType.toString() : ''
      this.form.specialtyId1Old = userInfo.specialtyId1.toString()
      this.changePersonType(userInfo.personType)
      this.changeSpecialtyId1(userInfo.specialtyId1)
      this.form.title = userInfo.title ? userInfo.title.toString() : ''
      this.form.getTitleDate = userInfo.getTitleDate
      this.form.occupationType = userInfo.occupationType ? userInfo.occupationType.toString() : ''
      this.form.practicingRequirements = userInfo.practicingRequirements ? userInfo.practicingRequirements.toString() : ''
      this.form.certificateNumber = userInfo.certificateNumber
      this.form.practisingCertificate = userInfo.practisingCertificate
      this.form.education = userInfo.education ? userInfo.education.toString() : ''
      this.form.duty = userInfo.duty ? userInfo.duty.toString() : ''
      this.form.birthday = userInfo.birthday
      this.form.nation = userInfo.nation ? userInfo.nation.toString() : ''
      this.form.politicsStatus = userInfo.politicsStatus ? userInfo.politicsStatus.toString() : ''
      this.form.specialtyId1 = userInfo.specialtyId1.toString()
      this.form.specialtyId2 = userInfo.specialtyId2.toString()
      this.isAlterOrg = userInfo.isAlterOrg //是否可修改所在单位
    },
    handleAvatarSuccess(response) {
      this.form.imageUrl = response.data.imgUrl
    },
    /**
     * @description: 验证原手机号验证码
     * @author: tanglitong
     */
    
    checkOldMobile() {
      if (!this.mobileFormOld.oldMobileCode) {
        this.$message.error('验证码不可为空')
        return
      }
      validateMobileCode({
        key: this.mobileFormOld.mobileCodeKey,
        code: this.mobileFormOld.oldMobileCode
      }).then(({data}) => {
        if (data.code !== 0) {
          this.$message.error(data.msg)
        } else {
          if (data.success === false) {
            this.$message.error(data.msg)
          } else {
            this.$message.success('原手机号验证成功')
            this.unbindActive = 1
          }
        }
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    
    changeTabs(type) {
      if (type == 1) {
        //基本信息
        this.baseVisible = true
        this.phoneVisible = false
        this.emailVisible = false
        this.pwdVisible = false
        this.cellVisible = false
      } else if (type == 2) {
        // 验证手机号
        if (this.mobileFormOld.oldMobile && this.form.isMobileVerify == 1) {
          this.oldMobileExist = true
          // this.$message.warning('手机号已验证')
        }
        this.baseVisible = false
        this.phoneVisible = true
        this.emailVisible = false
        this.pwdVisible = false
        this.cellVisible = false
      } else if (type == 3) {
        //验证邮箱
        if (this.emailForm.oldEmail && this.form.isEmailVerify == 1) {
          this.oldEmailExist = true
        }
        this.baseVisible = false
        this.phoneVisible = false
        this.emailVisible = true
        this.pwdVisible = false
        this.cellVisible = false
      } else if (type == 4) {
        //修改密码
        this.baseVisible = false
        this.phoneVisible = false
        this.emailVisible = false
        this.cellVisible = false
        this.pwdVisible = true
      } else if (type == 5) {
        //修改手机
        if (this.form.isMobileVerify != 1) {
          this.$message.warning('请先验证手机号')
          this.sendSmsButtonTextEditOldDisabled = true
        } else {
          this.sendSmsButtonTextEditOldDisabled = false
        }
        this.cellactive = 1
        // this.mobileFormEdit.oldMobile = this.userInfo.mobile
        this.baseVisible = false
        this.phoneVisible = false
        this.emailVisible = false
        this.pwdVisible = false
        this.cellVisible = true
      }
    },
    
    getOccupationType() {
      //执业类别
      getUserDictByColumType({columnType: 5}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.occupationTypeOptions = data
        }
      })
    },
    
    getRequirements() {
      //执业资格
      getUserDictByColumType({columnType: 6}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.requirementsOptions = data
        }
      })
    },
    
    getEducation() {
      //学历
      getUserDictByColumType({columnType: 9}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.educationOptions = data
        }
      })
    },
    
    getDuty() {
      //院内职务
      getUserDictByColumType({columnType: 7}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.dutyOptions = data
        }
      })
    },
    
    getNation() {
      //院内职务
      getUserDictByColumType({columnType: 8}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.nationOptions = data
        }
      })
    },
    
    getPoliticsStatus() {
      //政治面貌
      getUserDictByColumType({columnType: 10}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.politicsStatusOptiosn = data
        }
      })
    },
    
    changePersonType(val) {
      if (
        this.form.personTypeOld != '' &&
        this.form.personTypeOld != this.form.personType
      ) {
        this.form.specialtyId1 = ''
        this.form.specialtyId2 = ''
      }
      getSpecialty1Indexs({personType: val}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.specialtyId1Options = data
        }
      })
    },
    changeSpecialtyId1(val) {
      if (
        this.form.specialtyId1Old != '' &&
        this.form.specialtyId1Old != this.form.specialtyId1
      ) {
        this.form.specialtyId2 = ''
      }
      
      getSpecialty2Indexs({specialtyId1: val}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.specialtyId2Options = data
        }
      })
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.indexOf(queryString.toLowerCase()) >= 0
      }
    },
    searchDepartment(queryString, cb) {
      if (!this.form.isCustomComp && this.form.orgId) {
        getdepartmentByOrgId({
          orgId: this.form.orgId
        }).then((response) => {
          let {data} = response
          if (response.status == 200) {
            this.departmentList = data
            var restaurants = this.departmentList
            var results = queryString
              ? restaurants.filter(this.createFilter(queryString))
              : restaurants
            // 调用 callback 返回建议列表的数据
            cb(results)
          }
        })
      }
    },
    departmentSelect(item) {
      this.form.department = item.value
      this.form.departmentId = item.id
    },
    departmentBlur() {
      this.form.departmentId = ''
    },
    
    smsTimer() {
      if (this.time > 0) {
        this.time--
        // this.sendSmsButtonDisabled = true
        this.mobileForm.yzmbtn = true
        setTimeout(this.smsTimer, 1000)
      } else {
        this.mobileForm.yzmbtn = false
        // this.sendSmsButtonDisabled = false
      }
    },
    smsTimerOld() {
      if (this.timeOld > 0) {
        this.timeOld--
        this.sendSmsButtonDisabledOld = true
        setTimeout(this.smsTimerOld, 1000)
      } else {
        this.sendSmsButtonDisabledOld = false
      }
    },
    smsTimerNew() {
      if (this.timeNew > 0) {
        this.timeNew--
        this.sendSmsButtonDisabledNew = true
        setTimeout(this.smsTimerNew, 1000)
      } else {
        this.sendSmsButtonDisabledNew = false
      }
    },
    smsTimerEditOld() {
      if (this.timeEditOld > 0) {
        this.timeEditOld--
        this.sendSmsButtonTextEditOldDisabled = true
        setTimeout(this.smsTimerEditOld, 1000)
      } else {
        this.sendSmsButtonTextEditOldDisabled = false
      }
    },
    smsTimerEditNew() {
      if (this.timeEditNew > 0) {
        this.timeEditNew--
        this.mobileFormEditNew.yzmbtn = true
        setTimeout(this.smsTimerEditNew, 1000)
      } else {
        this.sendSmsButtonTextEditNewDisabled = false
        // sendSmsButtonTextEditNewDisabled
      }
    },
    
    emailTimer() {
      if (this.timeEmail > 0) {
        this.timeEmail--
        this.sendEmailButtonDisabled = true
        setTimeout(this.emailTimer, 1000)
      } else {
        this.sendEmailButtonDisabled = false
      }
    },
    /**
     * @description: 发送手机验证码
     * @return {*}
     * @param refName
     * @param valName
     * @param type //1:验证手机号,4:修改手机号-旧手机号,5:修改手机号-新手机号
     */
    sendSmsMethod(refName, valName, type) {
      this.$refs[`${ refName }`].validateField(valName, (error) => {
        if (!error) {
          this.tipFlag = type
          
          if (this.tipFlag === 5) {
            //换绑手机号不能与原手机号一样
            if (this.userInfo.mobile === this.mobileFormEditNew.newMobile) {
              this.$message.warning('新手机号不能与原手机号一致')
              return
            }
          }
          this.verifyShow = true
        }
      })
    },
    
    sendEmailMethod() {
      this.$refs.emailForm.validateField('newEmail', (error) => {
        if (!error) {
          let timestamp = new Date().getTime()
          let sign = sha256(this.emailForm.newEmail + timestamp).toString()
          let param = {
            email: this.emailForm.newEmail,
            sign: sign,
            userId: this.userInfo.id,
            timestamp: timestamp,
            type: 1
          }
          sendEmail(param).then((response) => {
            let {data} = response
            if (response.status == 200) {
              if (data.status == 200) {
                this.$message({
                  message: data.msg,
                  type: 'success'
                })
                this.timeEmail = 60
                this.emailTimer()
              } else {
                this.$message({
                  message: data.msg,
                  type: 'warning'
                })
              }
            } else {
              this.$message.error('网络错误！')
            }
          })
        }
      })
    },
    
    editUserInfo() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.birthday != '' && this.form.birthday != undefined) {
            this.form.birthday = util.formatDate.format(
              new Date(this.form.birthday),
              'yyyy-MM-dd'
            )
          }
          if (
            this.form.getTitleDate != '' &&
            this.form.getTitleDate != undefined
          ) {
            this.form.getTitleDate = util.formatDate.format(
              new Date(this.form.getTitleDate),
              'yyyy-MM-dd'
            )
          }
          this.fullscreenLoading = true
          updateStudent(this.form)
            .then((response) => {
              var data = response
              if (data.status == 200) {
                this.isAlterOrg = 1
                setTimeout(() => {
                  this.fullscreenLoading = false
                }, 500)
                this.$message({
                  type: 'success',
                  message: '操作成功！',
                  duration: 1000,
                  onClose: () => {
                    this.getUserInfo()
                  }
                })
              } else {
                this.fullscreenLoading = false
                this.$message({
                  type: 'warning',
                  message: '操作失败！'
                })
              }
            })
            .catch(() => {
              this.fullscreenLoading = false
            })
        }
      })
    },
    
    editUserMobile(refName, type) {
      this.$refs[`${ refName }`].validate((valid) => {
        if (valid) {
          let param = {}
          if (type === 1) {
            param = {
              mobile: this.mobileForm.newMobile,
              code: this.mobileForm.mobileCode
            }
            smsvalidate(param).then((res) => {
              if (res.code == 0) {
                bindMobile(param).then((res) => {
                  this.$alert('绑定成功,页面将重新加载', '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                    showClose: false,
                    callback: () => {
                      this.$router.go(0)
                    }
                  })
                })
              } else {
                this.$message.warning(res.msg)
              }
            })
          } else if (type === 2) {
            param = {
              uuid: this.userInfo.uuid,
              oldCode: this.mobileFormEdit.mobileCode,
              mobile: this.mobileFormEditNew.newMobile,
              code: this.mobileFormEditNew.mobileCode
            }
            if (this.userInfo.mobile == this.mobileFormEditNew.newMobile) {
              this.$message.warning('新手机号不能与原手机号一致')
              return
            }
            smsvalidate({
              mobile: this.mobileFormEditNew.newMobile,
              code: this.mobileFormEditNew.mobileCode
            }).then((res) => {
              if (res.code == 0) {
                updatebindMobile(param).then((res) => {
                  this.$alert('修改成功,页面将重新加载', '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                    showClose: false,
                    callback: () => {
                      this.$router.go(0)
                    }
                  })
                })
              } else {
                this.$message.warning(res.msg)
              }
            })
          }
          
          // updateMobile(param).then((response) => {
          //   var data = response.data
          //   if (data.status == 200) {
          //     this.$alert('绑定成功,页面将重新加载', '提示', {
          //       confirmButtonText: '确定',
          //       type: 'success',
          //       showClose: false,
          //       callback: () => {
          //         this.$router.go(0)
          //       },
          //     })
          //   } else {
          //     this.$message({
          //       type: 'error',
          //       message: data.msg,
          //     })
          //   }
          // })
        } else {
          return false
        }
      })
    },
    
    editUserEmail() {
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          let param = {
            email: this.emailForm.newEmail,
            userId: this.userInfo.id,
            code: this.emailForm.emailCode
          }
          updateEmail(param).then((response) => {
            var data = response
            if (data.status == 200) {
              this.$message({
                type: 'success',
                message: '操作成功！'
              })
              this.emailForm.oldEmail = this.emailForm.newEmail
              this.oldEmailExist = true
              this.emailForm.newEmail = ''
              this.emailForm.emailCode = ''
            } else {
              this.$message({
                type: 'warning',
                message: '操作失败！'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    
    editUserPwd() {
      this.$refs.pwdForm.validate((valid) => {
        let param = {
          newPwd: md5(this.pwdForm.newPwd).toString(),
          userId: this.userInfo.id
        }
        if (valid) {
          updatePassword(param).then((response) => {
            var data = response
            if (data.status == 200) {
              this.$alert('修改密码成功！请点击“确定”并重新登录！', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                  this.userLogout()
                  this.$router.push('/')
                }
              })
              this.pwdForm.oldPwd = ''
              this.pwdForm.newPwd = ''
              this.pwdForm.reNewPwd = ''
            } else {
              this.$message({
                type: 'warning',
                message: '操作失败！'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    SpecialCharactersReg() {
      return SpecialCharactersReg
    },
    NumberReg() {
      return NumberReg
    },
    UppercaseLowercaseReg() {
      return UppercaseLowercaseReg
    },
    PasswordLengthRge() {
      return PasswordLengthRge
    }
  },
  watch: {
    $route() {
      if (this.$route.query.pwdVisible != undefined) {
        if (this.$route.query.pwdVisible == true) {
          this.changeTabs(4)
        }
      } else if (this.$route.query.baseVisible != undefined) {
        if (this.$route.query.baseVisible == true) {
          this.changeTabs(1)
        }
      }
    }
  }
}
</script>
<style scoped>
p.new_zc_sucess {
  font-size: 30px;
  line-height: 40px;
  width: 245px;
  height: 40px;
  margin: 0 auto;
  padding-left: 36px;
  text-align: left;
  color: #66A000;
  background: url(../../assets/img-4/sucess_bg.gif) no-repeat left center;
}

p.new_zc_welcome {
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}

p.new_zc_welcome span,
p.new_zc_welcome a {
  color: #FF5300;
}

p.new_zc_welcome a:hover {
  text-decoration: underline;
}

.self {
  margin-bottom: 2px !important;
}

.verifyMain {
  position: absolute;
  z-index: 9999;
  top: -96px;
  left: 0;
  padding: 12px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  background-color: #FFFFFF;
}

.step {
  width: 800px;
  margin-bottom: 15px;
//margin-left: 45px; background: #FAFAFA;
}

.stepdiv {
  width: 100%;
  /* margin-left: 55px; */
}

.mobileFormEdit {
  margin-left: 80px;
}

.baseInput {
  width: 370px;
  height: 40px;
}

.avatar {
  display: block;
  width: 108px;
  height: 108px;
}

.getCode {
  display: inline-block;
  width: 100px;
  height: 28px;
  margin-left: 20px;
  cursor: pointer;
  text-align: center;
  color: #FFFFFF;
  background: #38BCD5;
}

.new_upload_head {
  position: absolute;
  z-index: 9;
  top: 10px;
  right: 10px;
  width: 112px;
  height: 150px;
  text-align: center;
}

.new_upload_head > form > .el-form-item {
  margin-bottom: 0;
}

.new_upload_head span.new_upload_head_text {
  font-size: 12px;
  line-height: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  width: 110px;
  padding-bottom: 12px;
  text-align: center;
}

.new_upload_head img.avatar {
  border: 1px #E8E8E8 solid;
}

.new_userInfo_box {
  padding: 20px 0 0 30px;
}

.new_reminder_txt {
  font-size: 13px;
  line-height: 23px;
  position: relative;
  height: 48px;
  margin-bottom: 30px;
  padding-left: 50px;
  text-align: left;
  color: #888888;
}

.new_reminder_txt span {
  font-size: 30px;
  line-height: 30px;
  position: absolute;
  top: 7px;
  left: 0;
  display: block;
  width: 36px;
  height: 36px;
  text-align: center;
  color: #38BCD5;
  border: 3px #38BCD5 solid;
  border-radius: 23px;
}
</style>
<style>
.el-step__head.is-success {
  color: #38BCD5 !important;
  border-color: #38BCD5 !important;
}

.el-step__title.is-success {
  color: #38BCD5 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/usercenter/EditUser.vue